// extracted by mini-css-extract-plugin
export default {"review__info":"InfoReview_review__info__zMcWU","review__info--title":"InfoReview_review__info--title__sKtux","review__info--item":"InfoReview_review__info--item__+3bUH"};